import { Box, type SxProps, Typography } from '@mui/material';
import { Image } from 'lucide-react';
import { type To } from 'react-router-dom';

import { ConditionalLinkWrapper } from '@modules/_shared/components/ConditionalLinkWrapper';
import { useLocale } from '@shared/hooks/locale';

type NoPhotosPlaceholderProps =
  | {
      to?: To;
      sx?: SxProps;
      height: number;
      ratio?: never;
    }
  | {
      to?: To;
      sx?: SxProps;
      height?: never;
      ratio: number;
    };

export const NoPhotosPlaceholder: React.FC<
  NoPhotosPlaceholderProps
> = props => {
  const { t } = useLocale();

  return (
    <ConditionalLinkWrapper
      link={props.to != null ? { to: props.to } : undefined}
    >
      <Box
        sx={{
          backgroundColor: 'grey.200',
          color: 'grey.400',
          position: 'relative',
          ...(props.sx ?? {}),
          ...(props.height != null
            ? { height: props.height }
            : { paddingTop: props.ratio * 100 + '%' }),
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            zIndex: 1,
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {/* white outlined disc lifts the icon off the gray background,
              which otherwise reads as gray-on-gray */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 56,
              height: 56,
              borderRadius: '50%',
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'grey.300',
            }}
          >
            <Image size={28} />
          </Box>
          <Typography variant="body2" sx={{ color: 'grey.500' }}>
            {t('No photo')}
          </Typography>
        </Box>
      </Box>
    </ConditionalLinkWrapper>
  );
};
